<template>
  <b-overlay :show="loading" rounded="sm" class="pt-3 pb-4 mb-3">
    <div class="col-12 mx-auto my-2" v-if="!unavailable">
      <!-- <div v-if="isOn"></div> -->
      <div v-if="videochiamata">
        <h1 v-if="isOn">
          Teleconsulto con
          {{
            this.$route.params.type == "professionista"
              ? videochiamata.consultoUsers.paziente.anagrafica.fullname
              : videochiamata.consultoUsers.professionista.anagrafica.fullname
          }}
        </h1>
        <h1 v-else>
          Teleconsulto con
          {{
            this.$route.params.type == "professionista"
              ? videochiamata.consultoUsers.paziente.anagrafica.fullname
              : videochiamata.consultoUsers.professionista.anagrafica.fullname
          }}
          concluso
        </h1>

        <!-- <h2>{{videochiamanta.data_inizio || moment('HH:mm')}}</h2> -->
      </div>

      <div
        class="d-flex justify-content-center"
        :class="isMobile && 'flex-wrap'"
      >
        <div
          v-if="isOn"
          class="d-flex justify-content-center px-0"
          :class="isMobile ? 'col-12 flex-wrap' : ' col-7'"
        >
          <div v-if="this.$route.params.type == 'professionista'">
            <div
              id="videopreview"
              class="mx-auto col-lg-8 col-sm-12 d-flex justify-content-center flex-column"
            >
              <b-spinner
                variant="primary m-auto"
                label="Spinning"
                v-if="notReady"
              ></b-spinner>
            </div>
            <div class="col-10 mx-auto mt-2 d-flex justify-content-center">
              <b-button
                variant="secondary rounded-pill font-weight-bold col-5 mx-auto text-capitalize"
                @click="toggleMute"
                :class="isMute ? 'disabled' : 'secondary'"
                >{{ isMute ? "silenziato" : "silenzia" }}</b-button
              >
              <b-button
                variant="secondary rounded-pill font-weight-bold col-5 mx-auto text-capitalize"
                @click="toggleVideo"
                :class="videoMute ? 'disabled' : 'secondary'"
                >{{ videoMute ? "ripristina video" : "oscura video" }}</b-button
              >
            </div>
            <div class="col-10 mx-auto mt-2 d-flex justify-content-center">
              <b-button
                variant="primary rounded-pill font-weight-bold col-5 mx-auto"
                @click="stopCall"
                >Chiudi</b-button
              >
            </div>
          </div>
          <div v-else class="col-12 mx-auto">
            <div
              id="videopreview"
              class="mx-auto col-lg-8 col-sm-12 d-flex justify-content-center flex-column"
            >
              <b-spinner
                variant="primary m-auto"
                label="Spinning"
                v-if="notReady"
              ></b-spinner>
            </div>
            <div class="col-10 mx-auto mt-2 d-flex justify-content-center">
              <b-button
                variant="primary rounded-pill font-weight-bold col-4 mx-auto"
                @click="stopCall"
                >Chiudi</b-button
              >
              <b-button
                variant="secondary rounded-pill font-weight-bold col-4 mx-auto text-capitalize"
                @click="toggleMute"
                :class="isMute ? 'disabled' : 'secondary'"
                >{{ isMute ? "silenziato" : "silenzia" }}</b-button
              >
              <b-button
                variant="secondary rounded-pill font-weight-bold col-4 mx-auto text-capitalize"
                @click="toggleVideo"
                :class="videoMute ? 'disabled' : 'secondary'"
                >{{ videoMute ? "ripristina video" : "oscura video" }}</b-button
              >
            </div>
          </div>
        </div>
        <div
          class="my-4"
          :class="isMobile ? 'col-12 mx-auto' : ' col-5 ml-0'"
          v-if="this.$route.params.type == 'professionista' && videochiamata"
        >
          <note-professionista :appunti="videochiamata.consulto.note" />
        </div>
      </div>
      <br />
      <div
        class="col-9 mx-auto"
        v-if="this.$route.params.type == 'professionista' && !isOn"
      >
        <conversazione :destinatario="videochiamata.consultoUsers.paziente" />
      </div>
      <!-- <div class="my-2 col-9 mx-auto">
        <note-professionista />
      </div>-->
    </div>
    <p v-else class="col-10 mx-auto text-center pt-4 font-weight-bold">
      Consulto non disponibile
    </p>
  </b-overlay>
</template>
<script>
import moment from "moment";
import NoteProfessionista from "@/components/consulto/NoteProfessionista";
import Conversazione from "@/components/Conversazione";
export default {
  name: "VideoConferenza",
  // props: ["consulto"],
  components: {
    NoteProfessionista,
    Conversazione,
  },
  data() {
    return {
      loading: true,
      channel: null,
      fm: null,
      client: null,
      localMedia: null,
      remoteMedia: null,
      videochiamata: null,
      clientName: null,
      token: null,
      isOn: true,
      connection: null,
      chatConnection: null,
      isMute: false,
      unavailable: false,
      notReady: true,
      layoutManager: null,
      isClosed: false,
      videoMute: false,
    };
  },
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    },
  },
  methods: {
    start() {
      this.isMute = false;
      this.unavailable = false;
      this.loading = false;

      var fm = window.fm;
      var gateway = process.env.VUE_APP_LIVEWITCH_GATEWAY;
      var secret = process.env.VUE_APP_LIVEWITCH_SECRET;
      var applicationId = process.env.VUE_APP_LIVEWITCH_APP_ID;
      var clientId = this.clientName;
      var channelId = this.videochiamata.channel_id;
      var client = null;
      var token = null;
      // var userId = fm.liveswitch.Guid.newGuid()
      //   .toString()
      //   .replace(/-/g, "");
      var userId = fm.liveswitch.Guid.newGuid()
        .toString()
        .replace(/-/g, "");
      var deviceId = this.clientName;
      var localMedia = null;

      client = new fm.liveswitch.Client(
        gateway,
        applicationId,
        userId,
        deviceId
      );
      this.client = client;

      //********Get token from ls server*********
      /*   var url = process.env.VUE_APP_VERSION + "videochiamata/client/tokens";
      var data = {
        userId: client.getUserId(),
        id: client.getId(),
        deviceId: client.getDeviceId(),
        channelId: channelId
      };
      var joinToken;
      this.$axios
        .post(url, data)
        .then(res => {
          console.log("get tokens", res);
          token = res.data.register;
          joinToken = res.data.join;
        })
        .catch(err => {
          console.log(err);
          // if (err && err.response.status === 401) {
          //   this.$router.go();
          // }
        }); */
      // ************Get token from ls server*********

      token = fm.liveswitch.Token.generateClientRegisterToken(
        applicationId,
        client.getUserId(),
        client.getDeviceId(),
        client.getId(),
        null,
        [new fm.liveswitch.ChannelClaim(channelId)],
        secret
      );

      var self = this;
      client
        .register(token)
        .then(function(channels) {
          // console.log("connected to channel: ".channels);

          var joinToken = fm.liveswitch.Token.generateClientJoinToken(
            applicationId,
            client.getUserId(),
            client.getDeviceId(),
            client.getId(),
            new fm.liveswitch.ChannelClaim(channelId),
            secret
          );

          // self.client
          client
            .join(channelId, joinToken)
            .then(function(channel) {
              // console.log("successfully joined channel");
              self.channel = channel;
              // channels.forEach((channel) => {
              var audioset = true;
              var videoset = {
                width: 320,
                height: 240,
                frameRate: 30,
              };
              localMedia = new fm.liveswitch.LocalMedia(audioset, videoset);
              var receiveOnly = false;
              var promise = new fm.liveswitch.Promise();
              var pluginConfig = new fm.liveswitch.PluginConfig();
              pluginConfig.setActiveXPath("./FM.LiveSwitch.ActiveX.cab");
              fm.liveswitch.Plugin.install(pluginConfig).then(() => {
                if (!fm.liveswitch.Plugin.isReady(!receiveOnly)) {
                  // Check if this browser is supported without local media.
                  if (fm.liveswitch.Plugin.isReady()) {
                    promise.reject(
                      alert(
                        "This browser supports WebRTC, but does not support media capture.\nTry receive-only mode!"
                      )
                    );
                  } else {
                    promise.reject(
                      alert(
                        "This browser does not support WebRTC, and no plugin could be found."
                      )
                    );
                  }
                }
              });
              self.localMedia = localMedia;
              localMedia.start().then(() => {
                //console.log("started local media");
                var layoutManager = new fm.liveswitch.DomLayoutManager(
                  document.getElementById("videopreview")
                );
                self.layoutManager = layoutManager;
                var localView = localMedia.getView();
                layoutManager.setLocalView(localView);
              });

              try {
                //P2P
                // console.log("check if u see", self.$route.params.type);
                //console.log("channel inst", channel);
                // console.log(
                // "get remote client infos",
                //  channel.getRemoteClientInfos()
                // );
                // if (self.$route.params.type == "professionista") {
                //*p2p offerer

                channel.addOnRemoteClientJoin(function(remoteClientInfo) {
                  /*   console.log(
                    "onremote offer (connessione professionista)REMOTE CLIENT JOINED CHANNEL",
                    remoteClientInfo
                  ); */

                  var remoteMedia = new fm.liveswitch.RemoteMedia();
                  var audioStream = new fm.liveswitch.AudioStream(
                    self.localMedia,
                    remoteMedia
                  );
                  var videoStream = new fm.liveswitch.VideoStream(
                    self.localMedia,
                    remoteMedia
                  );

                  var connection = channel.createPeerConnection(
                    remoteClientInfo,
                    audioStream,
                    videoStream
                  );
                  self.connection = connection;
                  // var layoutManager = new fm.liveswitch.DomLayoutManager(
                  //   document.getElementById("videopreview")
                  // );
                  self.layoutManager.addRemoteView(
                    remoteMedia.getId(),
                    remoteMedia.getView()
                  );

                  connection.addOnStateChange(function(c) {
                    // if (
                    //   c.getState() == fm.liveswitch.ConnectionState.Closing ||
                    //   c.getState() == fm.liveswitch.ConnectionState.Failing
                    // ) {
                    if (c.getState() == fm.liveswitch.ConnectionState.Closing) {
                      self.layoutManager.removeRemoteView(remoteMedia.getId());
                      self.layoutManager.unsetLocalView();
                      // self.isOn = false;
                      self.stopCall();
                    } else if (
                      c.getState() == fm.liveswitch.ConnectionState.Connected
                    ) {
                      console.log(connection, "Peer offer");
                    }
                  });
                  // connection.setIceServers([
                  //   new fm.liveswitch.IceServer(
                  //     "stun:stun.liveswitch.fm:3478"
                  //   ),
                  //   new fm.liveswitch.IceServer(
                  //     "turn:turn.liveswitch.fm:3478",
                  //     "test",
                  //     "pa55w0rd!"
                  //   ),
                  // ]);
                  connection
                    .open()
                    .then(function(result) {
                      // console.log("offerer's connection established", result);
                      self.notReady = false;
                      // if (result == null) {
                      //   self.localMedia
                      //     .stop()
                      //     .then(function(lm) {
                      //       console.log("media capture stopped");
                      //     })
                      //     .fail(function(err) {
                      //       console.log(err.message);
                      //     });
                      //   return self.localMedia.destroy();
                      // }
                    })
                    .fail(function(ex) {
                      console.log("an error occurred", ex);
                    });
                });
                // } else {
                //p2p answerer
                channel.addOnPeerConnectionOffer(function(peerConnectionOffer) {
                  /* console.log(
                    "onpeer offer(connessione paziente) ADD ON PEER CONNECTION ANSWER",
                    peerConnectionOffer
                  ); */

                  var remoteMedia = new fm.liveswitch.RemoteMedia();
                  self.layoutManager.addRemoteView(
                    remoteMedia.getId(),
                    remoteMedia.getView()
                  );
                  var audioStreamA;
                  var videoStreamA;

                  if (peerConnectionOffer.getHasAudio()) {
                    audioStreamA = new fm.liveswitch.AudioStream(
                      self.localMedia,
                      remoteMedia
                    );
                  }
                  if (peerConnectionOffer.getHasVideo()) {
                    videoStreamA = new fm.liveswitch.VideoStream(
                      self.localMedia,
                      remoteMedia
                    );
                  }

                  var connection = channel.createPeerConnection(
                    peerConnectionOffer,
                    audioStreamA,
                    videoStreamA
                  );
                  connection.setTag("peer-answer");
                  self.connection = connection;

                  connection.addOnStateChange(function(c) {
                    // if (
                    //   c.getState() == fm.liveswitch.ConnectionState.Closing ||
                    //   c.getState() == fm.liveswitch.ConnectionState.Failing
                    // ) {
                    if (c.getState() == fm.liveswitch.ConnectionState.Closing) {
                      self.layoutManager.removeRemoteView(remoteMedia.getId());
                      self.layoutManager.unsetLocalView();
                      // self.isOn = false;
                      self.stopCall();
                    } else if (
                      c.getState() == fm.liveswitch.ConnectionState.Connected
                    ) {
                      console.log(connection, "Peer answerer");
                    }
                  });
                  // connection.setIceServers([
                  //   new fm.liveswitch.IceServer(
                  //     "stun:stun.liveswitch.fm:3478"
                  //   ),
                  //   new fm.liveswitch.IceServer(
                  //     "turn:turn.liveswitch.fm:3478",
                  //     "test",
                  //     "pa55w0rd!"
                  //   ),
                  // ]);
                  connection
                    .open()
                    .then(function(result) {
                      // console.log(
                      //   "answerer's connection established",
                      //   result
                      // );
                      self.notReady = false;
                      // if (result == null) {
                      //   self.localMedia
                      //     .stop()
                      //     .then(function(lm) {
                      //       console.log("media capture stopped");
                      //     })
                      //     .fail(function(err) {
                      //       console.log(err.message);
                      //     });
                      //   return self.localMedia.destroy();
                      // }
                    })
                    .fail(function(ex) {
                      console.log("an error occurred", ex);
                    });
                });
                //}
                //P2P
              } catch (err) {
                console.log("error tru catch", err);
              }
            })
            .fail(function(ex) {
              console.log("failed to join channel", ex);
            });
        })
        .fail(function(ex) {
          console.log("registration failed", ex);
        });
    },
    fetchData() {
      var url =
        process.env.VUE_APP_VERSION +
        "videochiamata/" +
        this.$route.params.hash;

      this.$axios
        .get(url)
        .then((res) => {
          this.videochiamata = res.data.data;
          if (!this.videochiamata) {
            this.loading = false;
            return (this.unavailable = true);
          }
          // console.log("videochiuamata", this.videochiamata);
          if (this.$route.params.type == "professionista") {
            this.clientName = this.videochiamata.consultoUsers.professionista.anagrafica.fullname;
          } else {
            this.clientName = this.videochiamata.consultoUsers.paziente.anagrafica.fullname;
          }
          if (this.videochiamata !== null) {
            this.setStartDate();
          } else {
            this.loading = false;
            this.unavailable = true;
          }

          // this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          // if (err && err.response.status === 401) {
          //   this.$router.go();
          // }
        });
    },
    setStartDate() {
      if(this.videochiamata && this.videochiamata.data_inizio){
         return this.checkPermission() && this.start();
      }
      var url =
        process.env.VUE_APP_VERSION +
        "videochiamata/" +
        this.$route.params.hash;
      var data = { data_inizio: moment().format("YYYY-MM-DD HH:mm:ss") };

      this.$axios
        .put(url, data)
        .then((res) => {
          this.videochiamata = res.data.data;
          // console.log(this.videochiamata);
          if (this.$route.params.type == "professionista") {
            this.clientName = this.videochiamata.consultoUsers.professionista.anagrafica.fullname;
          } else {
            this.clientName = this.videochiamata.consultoUsers.paziente.anagrafica.fullname;
          }
          //TO ADD BEFORE PROD
          this.checkPermission() && this.start();
          // this.start();
        })
        .catch((err) => {
          // console.log(err);
          if (err.response && err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    checkPermission() {
      var start = moment(this.videochiamata.consulto.data_inizio);
      var end = moment(this.videochiamata.consulto.data_fine);
      var now = moment();
      // console.log(now, start);
      // if (start.isAfter(now) || start.isSame(now)) {
      //   if (end.isBefore(now) || end.isSame(now)) {
      //     return true;
      //   }
      // }
      if (now.isAfter(start) && now.isBefore(end)) {
        return true;
      }

      this.loading = false;
      this.unavailable = true;
      return false;
    },
    setEndDate() {
      var url =
        process.env.VUE_APP_VERSION +
        "videochiamata/" +
        this.$route.params.hash;
      var data = { data_fine: moment().format("YYYY-MM-DD HH:mm:ss") };

      this.$axios
        .put(url, data)
        .then((res) => {
          this.videochiamata = res.data.data;
          // console.log(this.videochiamata);
          if (this.$route.params.type == "professionista") {
            this.clientName = this.videochiamata.consultoUsers.professionista.anagrafica.fullname;
          } else {
            this.clientName = this.videochiamata.consultoUsers.paziente.anagrafica.fullname;
          }
          // this.start();

          // this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    stopCall() {
      this.localMedia
        .stop()
        .then(function(lm) {
          console.log("media capture stopped");
          this.localMedia.destroy();
        })
        .fail(function(err) {
          console.log(err.message);
        });
      if (this.connection) {
        this.connection
          .close()
          .then(function(result) {
            console.log("connection closed");
          })
          .fail(function(ex) {
            console.log("an error occurred");
          });
      }
      this.client
        .leave(this.videochiamata.channel_id)
        .then(function(channel) {
          console.log("left the channel");
        })
        .fail(function(ex) {
          console.log("failed to leave the channel");
        });
      this.client
        .unregister()
        .then(function(result) {
          console.log("unregistration succeeded");
        })
        .fail(function(ex) {
          console.log("unregistration failed");
        });
      this.isOn = false;
      this.isClosed = true;
      this.setEndDate();
    },
    toggleMute() {
      this.isMute = !this.isMute;
      this.localMedia.setAudioMuted(this.isMute);
    },
    toggleVideo() {
      this.videoMute = !this.videoMute;
      this.localMedia.setVideoMuted(this.videoMute);
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    // this.start();
  },
};
</script>
<style>
#videopreview {
  /* width: 300px;
  height: 200px; */
  width: 70vw;
  height: 50vh;
}
.fm-video > video {
  position: initial !important;
}
</style>
